import Pdf from "imgtopdf";
import moment from 'moment'; 

const { imgToPdf } = Pdf;
const noMonth = ['0.00', '2.20', '2.30', '3.50', '3.60', '4.20', '4.50', '7.30', '7.60', '9.90', '5.50'];

export default async function imgSave(id, multiple = 1.5, sort, date = moment().format('YYYY-MM')) {

    return new Promise((res, rej) => {
        imgToPdf(id, multiple).then(img => {

            fetch('/getPdf?' + `sort=${sort}&year=${moment(date).format('YYYY')}${!noMonth.includes(sort) ? `&month=${moment(date).format('MM')}` : "&month=null"}`, { credentials: 'include' }).then(x => x.json()).then(x => {
                let dataFrom = new FormData();
                dataFrom.append('img', img.img);
                dataFrom.append('sort', sort);
                dataFrom.append('height', img.canvas.height);
                dataFrom.append('width', img.canvas.width);
                dataFrom.append('year', moment(date).format('YYYY'));
                dataFrom.append('add_time', moment().format('YYYY-MM-DD HH:mm:ss'));

                if (!noMonth.includes(sort)) {
                    dataFrom.append('month', moment(date).format('MM'));
                }
                if (x.data && x.data.length > 0) {
                    dataFrom.append('id', x.data[0].id);
                }
                let headres = {
                    method: 'post',
                    credentials: 'include',
                    headers: {},
                    body: dataFrom
                }
                fetch('/addPdf', headres).then(x => x.json()).then(data => {
                    res(data)
                }).catch(err => {
                    rej(err)
                })
            }).catch(err => {
                rej(err)
            })
        }).catch(err => {
            rej(err)
        })
    })

}

function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
}

function blobToDataURL(blob, callback) {

    var a = new FileReader();

    a.onload = function (e) {

        callback(e.target.result);

    }

    a.readAsDataURL(blob);

}

function delay(time) {
    return new Promise((res, rej) => {
        const timer = setTimeout(() => {
            clearTimeout(timer)
            res()
        }, time);
    })
}


// WEBPACK FOOTER //
// ./src/components/table/saveImg.js